document.addEventListener('DOMContentLoaded', () => {
    const cocNumberParent = document.querySelector('#coc_number_field');
    const entityType = document.querySelector('#entity_type');
    const password = document.querySelector('#account_password_field');

    if (!entityType || !cocNumberParent || !password) {
        return;
    }

    entityType.addEventListener('change', () => {
        cocNumberParent.classList.remove('woocommerce-invalid');
        setTimeout(() => {
            password.classList.remove('woocommerce-invalid');
        }, 500);
    });
});
